module.exports = __webpack_public_path__ + "img/DP014_001.183f625b.png";